import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = {
  key: 1,
  class: "table-responsive pis-scroll"
}
const _hoisted_3 = { class: "table" }
const _hoisted_4 = {
  key: 0,
  style: {"width":"1%"}
}
const _hoisted_5 = {
  key: 1,
  style: {"width":"1%"}
}
const _hoisted_6 = {
  key: 2,
  style: {"width":"1%"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "ext-select-checkbox" }
const _hoisted_12 = ["checked", "onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 1,
  class: "fw-bold text-muted"
}
const _hoisted_16 = { class: "text-muted small" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  key: 1,
  class: "fw-bold text-muted"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["colspan"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_ItemCatalogsDetails = _resolveComponent("ItemCatalogsDetails")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    (_ctx.isReady && _ctx.componentOptions.visible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          (_ctx.productsItems && _ctx.productsItems.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("table", _hoisted_3, [
                  _createElementVNode("colgroup", null, [
                    (_ctx.componentOptions.selectable)
                      ? (_openBlock(), _createElementBlock("col", _hoisted_4))
                      : _createCommentVNode("", true),
                    (_ctx.previewEnabled)
                      ? (_openBlock(), _createElementBlock("col", _hoisted_5))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
                      return (_openBlock(), _createElementBlock("col", {
                        key: index,
                        style: _normalizeStyle({ width: col.width })
                      }, null, 4))
                    }), 128)),
                    (_ctx.componentOptions.detailsVisible)
                      ? (_openBlock(), _createElementBlock("col", _hoisted_6))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_ctx.componentOptions.selectable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_7))
                        : _createCommentVNode("", true),
                      (_ctx.previewEnabled)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_8))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
                        return (_openBlock(), _createElementBlock("th", { key: index }, [
                          (col.headerTemplate)
                            ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                key: 0,
                                template: col.headerTemplate,
                                "template-props": { t: _ctx.t, col }
                              }, null, 8, ["template", "template-props"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(col.caption), 1)
                              ], 64))
                        ]))
                      }), 128)),
                      (_ctx.componentOptions.detailsVisible)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_9))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsItems, (item) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: item.productId
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass({
                  'bg-light': item.exactMatch,
                  'no-border-bottom': item['expanded'],
                  'ext-selected': _ctx.instance?.selection.isSelected(item),
                })
                        }, [
                          (_ctx.componentOptions.selectable)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "form-check-input",
                                    checked: _ctx.instance?.selection.isSelected(item),
                                    onClick: ($event: any) => (_ctx.instance?.selection.toggle(item))
                                  }, null, 8, _hoisted_12)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.previewEnabled)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                                _createVNode(_component_Clickable, {
                                  class: "d-flex ext-icon-preview",
                                  title: _ctx.t(_ctx.isPreviewDisabled(item) ? 'PreviewNotAvailable' : 'Preview', true),
                                  disabled: _ctx.isPreviewDisabled(item),
                                  onClick: _withModifiers(($event: any) => (
                      !_ctx.isPreviewDisabled(item) &&
                        _ctx.previewByProductId(
                          item.baseProduct?.productId || item.alternateProductId || item.productId,
                        )
                    ), ["prevent"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Icon, {
                                      glyph: "preview",
                                      lg: ""
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["title", "disabled", "onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
                            return (_openBlock(), _createElementBlock("td", { key: index }, [
                              (col.cellTemplate)
                                ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                    key: 0,
                                    template: col.cellTemplate,
                                    "template-props": {
                      col,
                      item,
                      instance: _ctx.instance,
                      catalogProductType: _ctx.catalogProductType,
                      CatalogProductTypeEnum: _ctx.CatalogProductTypeEnum,
                      t: _ctx.t,
                      emit: _ctx.emit,
                      details: _ctx.details,
                      attrValue: _ctx.attrValue,
                      attrValues: _ctx.attrValues,
                      baseProductDetails: _ctx.baseProductDetails,
                    }
                                  }, null, 8, ["template", "template-props"]))
                                : (col.dataField === 'ProductId')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      (!item.inactive)
                                        ? (_openBlock(), _createBlock(_component_Clickable, {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.details(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.attrValue(item, col.dataField)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.attrValue(item, col.dataField)), 1)),
                                      _createElementVNode("div", _hoisted_16, [
                                        (item.productType == _ctx.catalogProductType.Configured)
                                          ? (_openBlock(), _createElementBlock("em", _hoisted_17, [
                                              _createTextVNode(_toDisplayString(_ctx.t('ConfiguredProducts')) + " ", 1),
                                              _hoisted_18
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.customerClassification)
                                          ? (_openBlock(), _createElementBlock("em", _hoisted_19, [
                                              _createTextVNode(_toDisplayString(_ctx.t('CustomerClassification')) + ":  " + _toDisplayString(item.customerClassification) + " ", 1),
                                              _hoisted_20
                                            ]))
                                          : _createCommentVNode("", true),
                                        (item.baseProduct)
                                          ? (_openBlock(), _createElementBlock("em", _hoisted_21, [
                                              _createTextVNode(_toDisplayString(_ctx.t('BaseProductId')) + ":  ", 1),
                                              (!item.baseProduct.inactive)
                                                ? (_openBlock(), _createBlock(_component_Clickable, {
                                                    key: 0,
                                                    onClick: ($event: any) => (_ctx.baseProductDetails(item.baseProduct))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.baseProduct.productId), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.baseProduct.productId), 1)),
                                              _hoisted_23
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.attrValue(item, col.dataField)), 1)),
                              (col.showAllIdentifiers)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.attrValues(item, '#AllIdentifiers'), (val, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "small text-muted fw-bold",
                                      key: index
                                    }, _toDisplayString(val), 1))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          (_ctx.componentOptions.detailsVisible)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                                _createElementVNode("a", {
                                  href: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleItemDetails(item)), ["prevent"]),
                                  class: "btn btn-link text-dark d-flex align-items-center"
                                }, [
                                  _createVNode(_component_Icon, {
                                    glyph: item['expanded'] ? 'minus' : 'plus',
                                    class: "py-1",
                                    style: {"font-size":"1.1rem"}
                                  }, null, 8, ["glyph"])
                                ], 8, _hoisted_26)
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        (item['expanded'])
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                              (_ctx.componentOptions.selectable)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_28))
                                : _createCommentVNode("", true),
                              (_ctx.previewEnabled)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_29))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", {
                                colspan: _ctx.columns.length
                              }, [
                                _createVNode(_component_ItemCatalogsDetails, {
                                  item: item,
                                  t: _ctx.t,
                                  "all-catalogs": _ctx.showingAllCatalogs,
                                  "instance-id": _ctx.instance?.id
                                }, null, 8, ["item", "t", "all-catalogs", "instance-id"])
                              ], 8, _hoisted_30),
                              _hoisted_31
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}